import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

export const NewBidGroupDialog = ({open, handleClose, playerList, onPlayerChange, maxBidAmount, onMaxBidAmountChange, onSubmitBidGroup, hideAutoBidding = false}) => {
    return (
        <Dialog open={open} onClose={handleClose} closeAfterTransition={false}>
            <DialogTitle id="new-bid-group-dialog">
                New Nomination
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Player:
                </DialogContentText>
                <Autocomplete id="playerSelectionField" freeSolo style={{width: 500}} options={playerList}
                              getOptionLabel={(p) => `${p.first_name} ${p.last_name} (${p.pos} - ${p.team})`}
                              onChange={onPlayerChange}
                              renderInput={(params) => (
                                  <TextField {...params} label="Search" margin="normal" variant="outlined"/>
                              )}/>
                {!hideAutoBidding &&
                    <div>
                        <DialogContentText style={{paddingTop: 40}}>
                            Auto-bid up to (optional):
                        </DialogContentText>
                        <TextField id="maxBidAmountField" label="Amount" variant="outlined" type="number"
                                   value={maxBidAmount ? maxBidAmount : ''}
                                   onChange={onMaxBidAmountChange}/>
                    </div>
                }
                <br/>
                <Button variant="contained" type="submit" color="primary" style={{float: "right"}}
                        onClick={onSubmitBidGroup}>Submit</Button>
            </DialogContent>
        </Dialog>
    );
}